import './App.css';
import bannerfuturelink from './FL.png';
import iconlink from './link.svg';
import javascripticon from './Javascript.svg'
import reacticon from './React.svg'
import nodeicon from './nodejs.svg'
import mysqlicon from './mysql.svg'
import stticon from './stt.svg'
import bannerinfidea from './infidea.png'
import banneraci from './acitelkom.png'
import bannermtf from './mtfmandiri.png'
import bannerjardinx from './jardinxlp.png'
import bannerindi from './indi.png'
import bannermilkyverse from './milkyverse.png'
import bannerdtpai from './dtpai.png'
import bannergroglo from './groglo.png'
import { Link } from 'react-router-dom'

function ArtificialIntelligence() {
  return (
<body className='Background' >

    <div className="Navbar">
      <Link to="/artificial-intelligence" className="nav-link">Artificial Intelligence</Link>
      <Link to="/web-app-development" className="nav-link">Web & App Development</Link>
      <Link to="/blockchain" className="nav-link">Blockchain</Link>
    </div>
    
    <p className='Title' >Projects I’ve Worked on</p>

    <div className='Card3'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Telkom ACI</p>
          <p className='Deskripsi'>
          Mengembangkan platform interview berbasis website yang dapat diakses secara online. Menggunakan kapabilitas AI speech to text untuk membantu team asesor dalam melakukan penilaian terhadap pelamar.          </p>
          <img className='Banner' src={banneraci} alt='acitelkom' ></img>
        </div>
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={javascripticon} alt='Javascript'></img>
              <p>JavaScript</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nodeicon} alt='nodejs'></img>
              <p>NodeJS</p>
            </button>
          </div>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={mysqlicon} alt='mysql'></img>
              <p>MySQL</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={stticon} alt='stt'></img>
              <p>Speech to Text</p>
            </button>
          </div>
          <a href="https://admin-web-interview.infidea.dev/login-admin" className="Link" target="_blank" rel="noopener noreferrer">
           <img className="icon" src={iconlink} alt="link" />
           <p>Go to Telkom ACI</p>
          </a>
        </div>
      </div>
    </div>

    <div className='Card8'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>grotech.ai</p>
          <p className='Deskripsi'>
          Grotech.ai adalah perusahaan yang menawarkan solusi pencitraan estetika total untuk rambut, wajah, dan tubuh. Mereka menyediakan perangkat AI portable yang dirancang untuk berbagai prosedur estetika, termasuk analisis pertumbuhan rambut, pencitraan wajah standar, dan pencitraan tubuh untuk penghilangan rambut dan tato. Perangkat ini juga dilengkapi dengan asisten AI untuk wawancara pasien dan pencatatan klinis. Saat ini, lebih dari 700 praktik di seluruh dunia telah menggunakan sistem mereka.
          </p>
          <img className='Banner' src={bannergroglo} alt='groglo' ></img>
        </div>
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={javascripticon} alt='Javascript'></img>
              <p>JavaScript</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nodeicon} alt='nodejs'></img>
              <p>NodeJS</p>
            </button>
          </div>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={mysqlicon} alt='mysql'></img>
              <p>MySQL</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={stticon} alt='stt'></img>
              <p>Speech to Text</p>
            </button>
          </div>
          <a href="https://www.grotech.ai/" className="Link" target="_blank" rel="noopener noreferrer">
           <img className="icon" src={iconlink} alt="link" />
           <p>Go to grotech.ai</p>
          </a>
        </div>
      </div>
    </div>

    <div className='Card9'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>DTP AI</p>
          <p className='Deskripsi'>
          DTP AI adalah sebuah platform yang berisi bermacam-macam kapabilitas AI. Web tersebut dikembangkan dengan tujuan untuk mendesentralisasikan kapabilitas AI dan dapat digunakan secara langsung oleh pengguna sehingga pengguna mudah memahami.
          </p>
          <img className='Banner' src={bannerdtpai} alt='dtpai' ></img>
        </div>
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={javascripticon} alt='Javascript'></img>
              <p>JavaScript</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={nodeicon} alt='nodejs'></img>
              <p>NodeJS</p>
            </button>
          </div>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={mysqlicon} alt='mysql'></img>
              <p>MySQL</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={stticon} alt='stt'></img>
              <p>Speech to Text</p>
            </button>
          </div>
          <a href="https://dtp-ai.infidea.dev" className="Link" target="_blank" rel="noopener noreferrer">
           <img className="icon" src={iconlink} alt="link" />
           <p>Go to DTP AI</p>
          </a>
        </div>
      </div>
    </div>

    <div className='footer'>
      <a href="https://infidea.id/" className="namefooter" target="_blank" rel="noopener noreferrer">
        <p>2025 Copyright © infidea</p>
      </a>
    </div>
</body>
);
  

  
}

export default ArtificialIntelligence;
